import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoutes from './route';
// import reportWebVitals from './reportWebVitals';
import { ApiProvider } from './providers/ApiProvider';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <ApiProvider>
        <AppRoutes/>
      </ApiProvider>
    </React.StrictMode>
  );
} else {
  console.error("Root element not found");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
